import { Box, Typography, Button, Link, Checkbox } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
// import BizDashWire from "../../assets/BizDashWrfrm.png";
// import CreateStockProduct from "../../assets/createStockProduct.png";
// // import CreateContainer from "../../assets/createContainer.png";
// import ProcessOrders from "../../assets/processOrders.png";
// import EditPhotos from "../../assets/editPhotos.png";
// import inventory from "../../assets/inventory.png";
import orderManagement from "../../assets/businessdashboard/orderManagement.png";
import orderManagementV1 from "../../assets/businessdashboard/orderManagementV1.png";
// import orderDetails from "../../assets/orderDetails.png";
// import CreateCustomerOrder from "../../assets/createCustomerOrder.png";
import orderManagementdemo from "../../assets/businessdashboard/ordermanagementdemo.mov";
// import inventorydemo from "../../assets/businessdashboard/filterbardemo.mov";
const BizDashboard = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      m="30px auto"
      p="30px"
      maxWidth="80%"
      border="2px solid #E5E8E8"
      borderRadius="12px"
      boxShadow="0px 3px 10px rgba(0, 0, 0, 0.1)"
      backgroundColor={colors.primary[900]}
    >
      {/* Back Button */}
      <Button
        startIcon={<ArrowBack sx={{ transition: "transform 0.2s ease" }} />}
        onClick={() => navigate(-1)}
        sx={{
          color: "colors.primary[200]",
          backgroundColor: "transparent",
          fontWeight: "bold",
          "&:hover .MuiButton-startIcon": {
            transform: "translateX(-7px)",
          },
        }}
      >
        Back
      </Button>
      {/* Project Title */}
      <Typography
        variant="h3"
        fontWeight="bold"
        color={colors.primary[200]}
        my={2}
      >
        <Link
          // href="https://github.com/williamjiang26"
          target="_blank"
          underline="none"
          color="inherit"
          sx={{
            textDecoration: "none",
            px: 1,
            borderRadius: 1,
            transition: "background-color 0.3s",
            // "&:hover": {
            //   backgroundColor: "grey.300",
            //   cursor: "pointer",
            // },
          }}
        >
          Business Dashboard
        </Link>
      </Typography>
      {/* Project Description */}
      <Typography variant="h5" color={colors.primary[200]} my={3}>
        A dashboard to manage customer orders in a retail business
      </Typography>
      {/* Problem */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Problem:
      </Typography>
      <Box component="ul" sx={{ pl: 3, color: colors.primary[200], mb: 3 }}>
        Information about a customer order are scattered from text to emails to
        a verbal comment. When it comes time to place the customer order, it is
        difficult to remember where and what those details were. Additionally
        say a friend of a customer wants to purchase a similar product, sifting
        through paperwork for a customer order is impossible. The business
        dashboard is designed on the workflow of sales reps and the manager from
        creating a stock product to fulfilling the customer order, leveraging
        software to store isolated documents together and search any customer
        order detail quickly.
      </Box>
      {/* Demo Section */}
      {/* <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Demo:
      </Typography>
      <Box
        height="200px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        border="2px dashed #AAB7B8"
        borderRadius="8px"
        mb={1}
      >
        <Typography color="#839192">Demo Placeholder</Typography>
      </Box> */}
      {/* <Box>
        <Box
          sx={{
            mt: 1,

            overflow: "hidden",
            transition: "all 0.3s cubic-bezier(0.3, 0, 0.2, 1)",
          }}
          data-visible={true}
        >
          <Typography
            variant="h5"
            fontWeight="bold"
            color={colors.primary[200]}
            mb={1}
          >
            Order Management
          </Typography>
          <img src={ecomm} alt="" width="100%" />
        </Box>
        <Box
          sx={{
            mt: 1,

            overflow: "hidden",
            transition: "all 0.3s cubic-bezier(0.3, 0, 0.2, 1)",
          }}
          data-visible={true}
        >
          <Typography
            variant="h5"
            fontWeight="bold"
            color={colors.primary[200]}
            mb={1}
          >
            Inventory Management
          </Typography>
          <img src={productDescription} alt="" width="100%" />
        </Box>
        <Box
          sx={{
            mt: 1,
            overflow: "hidden",
            transition: "all 0.3s cubic-bezier(0.3, 0, 0.2, 1)",
          }}
          data-visible={true}
        >
          <Typography
            variant="h5"
            fontWeight="bold"
            color={colors.primary[200]}
            mb={1}
          >
            Accounting, Auditing, Bookkeeping
          </Typography>
          <img src={img} alt="" width="100%" />
        </Box>
      </Box> */}
      {/* <Box p={1}>
        <Typography
          variant="h5"
          fontWeight="bold"
          color={colors.primary[200]}
          mb={1}
        >
          Demo:
        </Typography>
        <iframe
          src="https://www.youtube.com/embed/BMQ2kV-p5as?autoplay=0&mute=1&loop=1"
          title="video"
          allow="autoplay"
          frameborder="0"
          style={{
            width: "100%",
            aspectRatio: "16 / 9",
            height: "auto",
          }}
        ></iframe>
      </Box> */}
      {/* Technical Challenges */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Technical Challenges:
      </Typography>
      <Box component="ul" sx={{ pl: 3, color: "#5D6D7E", mb: 3 }}>
        <li>Designing polished, performant UI components</li>
        <li>Implementing order processing feature</li>
        <li>
          Modeling customer orders, products, product orders, order tickets,
          containers attributes and relations
        </li>
        <li>Implement caching and optimizing queries for UI responsiveness</li>
        <li>Managing production environment on AWS</li>
      </Box>
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Future Features:
      </Typography>
      <Box
        component="ul"
        sx={{
          listStyle: "none",
          pl: 0,
          color: "#5D6D7E",
          "& li": {
            display: "flex",
            alignItems: "center",
          },
        }}
      >
        {["Filter Bar", "Customer Chats", "Schedule Orders"].map((item) => (
          <li>
            <Checkbox sx={{ fontSize: 18, color: "#5D6D7E" }} checked={true} />
            {item}
          </li>
        ))}
      </Box>
      {/* Technologies used */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Tech Stack:
      </Typography>
      <Box
        display={"flex"}
        flexWrap="wrap"
        sx={{ pl: 3, color: colors.primary[200], mb: 3 }}
      >
        {[
          "TypeScript",
          "Node.js",
          "Next.js",
          "React",
          "Shadcn",
          "Express.js",
          "Redux",
          "Zod",
          "Multer",
          "Lambda",
          "RDS",
          "S3",
          "Amplify",
          "Cognito",
        ].map((tech) => (
          <Box
            key={tech}
            component=""
            sx={{
              px: 1.5,
              py: 0.5,
              m: 0.5,
              border: `1px solid ${colors.primary[200]}`,
              borderRadius: "8px",
              color: colors.primary[200],
              fontSize: "0.875rem",
              backgroundColor: "rgba(255, 255, 255, 0.05)", // Subtle background
              "&:hover": {
                backgroundColor: colors.primary[200],
                color: "#000", // Contrast color on hover
                cursor: "default",
              },
            }}
          >
            {tech}
          </Box>
        ))}
      </Box>
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        System Design:
      </Typography>
      <Box>
        <Typography
          variant="h5"
          fontWeight="bold"
          color={colors.primary[200]}
          mb={1}
        >
          Design Changes:
        </Typography>
        <Box display={"flex"}>
          <img src={orderManagementV1} alt="" width="50%" />
          <img src={orderManagement} alt="" width="50%" />
        </Box>
        Design decision: Utilizes empty space, reduces friction from switching
        tabs, better visualization over ordering process and manage more orders
        at a glance
      </Box>
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Product Features:
      </Typography>
      {/* embed autoplay videos */}

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h7" mb={1}>
          Order Management
        </Typography>
        <video
          autoPlay
          muted
          loop
          playsInline
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            borderRadius: 7,
          }}
        >
          <source src={orderManagementdemo} type="video/mp4" />
        </video>
        {/* <Typography variant="h7" mb={1}>
          Filter Bar
        </Typography> */}
      </Box>
    </Box>
  );
};

export default BizDashboard;
